import React, { useRef, useState } from 'react';

import BuildingButtonSVG from 'assets/icons/building-1.svg';
import LightBulbButtonSVG from 'assets/icons/lightbulb.svg';
import Logo from 'assets/images/LogoIconAndTextHorizontal.svg';
import New from 'assets/images/tutorial1-new.png';
import Tutorial1 from 'assets/images/tutorial1.png';
import Tutorial2 from 'assets/images/tutorial2.png';
import Tutorial3 from 'assets/images/tutorial3.png';
import Tutorial4 from 'assets/images/tutorial4.png';

import { Button, Carousel } from 'antd';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import { useNavigate } from 'react-router-dom';
import { ProgressStep } from './Progress';

const contentStyle: React.CSSProperties = {
    margin: 0,
    height: 'fit-content',
    color: '#192f51',
    fontSize: '22px',
    fontWeight: 'bold',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '20px',
};

export const Tutorial = () => {
    const navigate = useNavigate();
    const [step, setStep] = useState<number>(0);
    const slider: any = useRef();

    const onProcessClick = (value: number) => {
        setStep(value);
        slider.current.goTo(value);
    };

    return (
        <section
            className="width-full-screen center-inside"
            style={{
                height: '100vh',
            }}
        >
            <div style={{ width: 1000 }}>
                <Carousel
                    dots={false}
                    ref={(ref) => {
                        slider.current = ref;
                    }}
                >
                    <div>
                        <div style={contentStyle} className="width-full-screen">
                            <img alt="tutorial1" src={Tutorial1} />
                            <img alt="logo" src={Logo} style={{ width: 260 }} />
                            <div className="strong">
                                <img className="new" alt="new" src={New} />
                                ワンルームマンションオークションシステム
                            </div>
                            <div>
                                ワンルームマンションの<span className="blue">売りたい</span>と
                                <span className="blue">買いたい</span>
                                をつなぐオークションアプリです。
                                <br />
                                決済までの取引の全てをアプリ上で完結することが可能です。
                            </div>
                        </div>
                    </div>
                    <div>
                        <div style={contentStyle} className="width-full-screen center-inside">
                            <img alt="tutorial2" src={Tutorial2} />
                            <div className="strong">安心安全の売却サポート</div>
                            <div>
                                最新のデータを基にした相場価格査定から、あなたが物件の売り出し価格を決定できます。
                                <br />
                                必要な連絡はアプリ内で完結し、面倒な営業電話は一切ありません。
                                <br />
                                取引終了まで、ワンルームオークションがしっかりあなたをサポートします。
                            </div>
                        </div>
                    </div>
                    <div>
                        <div style={contentStyle} className="width-full-screen center-inside">
                            <img alt="tutorial3" src={Tutorial3} />
                            <div className="strong">これまでにない購入体験</div>
                            <div>
                                検討に必要なデータベース、シミュレーションを備え、
                                <br />
                                価格もタイミングも、あなたの意志で決めることができます。
                                <br />
                                オークション形式での購入で、
                                <br />
                                価格を抑えたより高利回りでの投資が可能になりました。
                            </div>
                        </div>
                    </div>
                    <div>
                        <div style={contentStyle} className="width-full-screen center-inside">
                            <img alt="tutorial4" src={Tutorial4} />
                            <div className="strong">ようこそ、新しい不動産取引へ</div>
                            <div>
                                さあ、あなたは物件を売りたいですか？買いたいですか？
                                <br />
                                まずは匿名で使ってみましょう！
                            </div>
                        </div>
                    </div>
                </Carousel>
                <div style={{ width: '100%', marginTop: 16 }} className="center-inside">
                    <ProgressStep currentStep={step} steps={4} onClick={onProcessClick} />
                </div>
                {step !== 3 ? (
                    <div style={{ width: '100%', marginTop: 64 }} className="center-inside">
                        <Button
                            className="button-login-text"
                            type="primary"
                            style={{
                                width: 343,
                                height: 56,
                                fontSize: 18,
                                fontWeight: 700,
                            }}
                            onClick={() => {
                                const nextStep = step + 1;
                                setStep(nextStep);
                                slider.current.goTo(nextStep);
                            }}
                        >
                            次へ
                        </Button>
                    </div>
                ) : (
                    <>
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                width: 343,
                                margin: 'auto',
                                marginTop: 64,
                            }}
                        >
                            <div
                                className="button-style glow-on-hover center-inside"
                                style={{
                                    width: 167,
                                    height: 'fit-content',
                                }}
                                onClick={() =>
                                    navigate(
                                        `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_056_01}`,
                                    )
                                }
                            >
                                <img alt="" src={BuildingButtonSVG} />
                            </div>
                            <div
                                className="button-style glow-on-hover center-inside"
                                style={{
                                    width: 167,
                                    height: 'fit-content',
                                }}
                                onClick={() =>
                                    navigate(
                                        `${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_002_01}`,
                                    )
                                }
                            >
                                <img alt="" src={LightBulbButtonSVG} />
                            </div>
                        </div>
                        <div
                            style={{
                                marginTop: 16,
                                textAlign: 'center',
                                height: 48,
                            }}
                            className="text-bottom center-inside cursor-pointer"
                            onClick={() =>
                                navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_002_01}`)
                            }
                        >
                            まだ、決まってない
                        </div>
                    </>
                )}
            </div>
        </section>
    );
};
